// extracted by mini-css-extract-plugin
export default {"container":"style_container__Ijjrq","header":"style_header__A3cyA","content":"style_content__ff3vu","question":"style_question__iuJWI"};